import React from 'react';
import '../../../css/Turismo/turismo.css';

const Turismo = () => (
  <div>
    <div className="turismo-portada">
      <div className="turismo-portada-overlay">
        <span>
          CIUDAD DE OLIVA<br />GUÍA TURÍSTICA
        </span>
      </div>
    </div>

    <nav className="menu-turismo">
      <ul className="nav-turismo">
        <li><a href="/turismo/lugares-de-la-ciudad">Lugares de la Ciudad</a></li>
        <li><a href="/turismo/recorre-oliva">Recorré Oliva</a></li>
        <li><a href="/turismo/eventos-anuales">Eventos Anuales</a></li>
        {/* <li><a href="#proximos-eventos">Próximos Eventos</a></li> */}
      </ul>
    </nav>

  </div>
);

export default Turismo;
